if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.testimonials__track');
        this.buttons = this.querySelectorAll('.testimonials__button');
        this.buttons.forEach((button) =>
          button.addEventListener('click', () => this.scrollByCard(Number(button.dataset.direction)))
        );
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.querySelectorAll('.testimonials__more').forEach((button) =>
          button.addEventListener('click', () => {
            const card = button.closest('.testimonials__card');
            const expanded = card.classList.toggle('is-expanded');
            button.setAttribute('aria-expanded', expanded);
          })
        );
        this.updateButtons();
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.testimonials__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
        this.buttons.forEach((button) => {
          const atEdge = Number(button.dataset.direction) < 0 ? this.track.scrollLeft <= 0 : this.track.scrollLeft >= maxScroll;
          button.disabled = atEdge;
        });
      }
    }
  );
}
